import {
  useGetMyLibraryChallenges,
  useGetMyLibraryExercises,
  useGetMyLibraryResources,
} from '_api';
import { LibraryItem } from '_api/types';
import { LIBRARYITEMTYPE } from '_constants';
import { useEffect, useMemo, useState } from 'react';

const useMyLibrary = ({
  page = 0,
  size = 1000,
}: { page?: number; size?: number } = {}) => {
  const { data: sharedChallenges, isLoading: isFetchingChallenges } =
    useGetMyLibraryChallenges({ page, size });
  const { data: sharedExercises, isLoading: isFetchingExercises } =
    useGetMyLibraryExercises({ page, size });
  const { data: sharedResources, isLoading: isFetchingResources } =
    useGetMyLibraryResources({ page, size });

  const isLoading = useMemo(
    () => isFetchingChallenges || isFetchingExercises || isFetchingResources,
    [isFetchingChallenges, isFetchingExercises, isFetchingResources],
  );

  const [myLibraryData, setMyLibraryData] = useState<LibraryItem[]>();

  useEffect(() => {
    if (!isLoading && sharedExercises && sharedChallenges && sharedResources) {
      const exercises = sharedExercises.map(
        (exercise) =>
          ({
            type: LIBRARYITEMTYPE.EXERCISE,
            data: exercise,
          }) as LibraryItem,
      );

      const challenges = sharedChallenges.map(
        (challenge) =>
          ({
            type: LIBRARYITEMTYPE.CHALLENGE,
            data: challenge,
          }) as LibraryItem,
      );

      const resources = sharedResources.map(
        (resource) =>
          ({
            type: LIBRARYITEMTYPE.RESOURCE,
            data: resource,
          }) as LibraryItem,
      );

      setMyLibraryData([...exercises, ...challenges, ...resources]);
    }
  }, [isLoading, sharedChallenges, sharedExercises, sharedResources]);

  return { isLoading, myLibraryData };
};

export default useMyLibrary;
